// export const BaseURL = 'http://192.168.100.226:8000';
// export const BaseURL = 'http://192.168.100.133:8096';
// export const BaseURL = 'http://127.0.0.1:8096';
// export const BaseURL = 'http://192.168.100.99:8073';
// export const BaseURL = 'http://192.168.1.52:8093'; 
// export const BaseURL = 'http://97.74.91.13:8080'; 
// export const BaseURL = 'https://luftek.luftekerp.com:8080'; 
// export const BaseURL = 'https://ctpl.luftekerp.com:8080'; 
export const BaseURL = 'https://api.luftekerp.com'; //Live API domain



export function mapHeaders(data, headers){
    return data.map((item) => {
        const newItem = {};
        Object.keys(item).map((key) => {
            const newKey = headers[key];
            newItem[newKey] = item[key];
        });
        return newItem;
    });
}

export const getToken = () => {
    return localStorage.getItem("token");
};
